module.exports = "/assets/data/fab55473ac5e3f3ccf7a2283c5a865d4-BD4.data.json";